import { useI18n } from "./i18n";

export type RetentionNotice = { sandboxID: string; operationID: string; state: string; errorCode: string; until: string | null };
export function RuntimeRetentionNotice({result}: {result: RetentionNotice}) {
 const {t} = useI18n();
 const text = result.state === "succeeded"
  ? result.until
   ? t(`运行实例 ${result.sandboxID} 已确认保留至 ${result.until}。`, `Runtime ${result.sandboxID} retention was confirmed until ${result.until}.`)
   : t(`运行实例 ${result.sandboxID} 已确认解除保留。`, `Runtime ${result.sandboxID} retention was cleared.`)
  : result.state === "pending"
   ? t(`保留结果待确认，请核对操作或命令 ${result.operationID}，勿重复创建操作。`, `Retention is unconfirmed. Check operation or command ${result.operationID}; do not create another operation.`)
   : t("保留修改未完成。请刷新实例状态，核对期限和实例身份后重试。", "Retention did not change. Refresh the runtime and check its deadline and identity before retrying.");
 return <div role={result.state === "failed" ? "alert" : "status"} className="administrator-message">{text}{result.state === "failed" ? ` (${result.errorCode})` : ""}</div>;
}
